import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var auditDetail = [{
  path: "audit-detail",
  name: "audit-detail",
  component: function component() {
    return import("./audit-detail.vue");
  }
}];